import { Link } from "@tanstack/react-router"
import { LogOut, Settings, UserCog } from "lucide-react"
import {
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@holigral/shared/ui/components/ui/sidebar"
import { useIsRouteActive } from "@holigral/shared/routing"
import { useLogout } from "@/auth"
import { LanguageSwitcher } from "@/profile"
import { useEffectiveTenantSlug } from "@/tenant"
import { useT } from "@/i18n"

export default function FooterMenu() {
  const { t } = useT()
  const tenantSlug = useEffectiveTenantSlug()
  const logout = useLogout()
  const isSettingsActive = useIsRouteActive({
    to: "/t/$tenantSlug/settings",
    fuzzy: true,
  })
  const isTenantAccountActive = useIsRouteActive({
    to: "/t/$tenantSlug/account",
    fuzzy: true,
  })
  const isPlainAccountActive = useIsRouteActive({ to: "/account", fuzzy: true })
  const isAccountActive = isTenantAccountActive || isPlainAccountActive

  return (
    <SidebarMenu>
      {tenantSlug && (
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={isSettingsActive}
            render={
              <Link to="/t/$tenantSlug/settings" params={{ tenantSlug }}>
                <Settings />
                {t("nav.settings")}
              </Link>
            }
          />
        </SidebarMenuItem>
      )}
      <SidebarMenuItem>
        <SidebarMenuButton
          isActive={isAccountActive}
          render={
            <Link
              to={tenantSlug ? "/t/$tenantSlug/account" : "/account"}
              params={tenantSlug ? { tenantSlug } : undefined}
            >
              <UserCog />
              {t("nav.account")}
            </Link>
          }
        />
        <SidebarMenuAction title={t("nav.logout")} onClick={logout}>
          <LogOut />
        </SidebarMenuAction>
      </SidebarMenuItem>
      <SidebarMenuItem className="group-data-[collapsible=icon]:hidden">
        <LanguageSwitcher align="start" />
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
